import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import {
  Container,
  Jumbotron,
  ListGroup,
  ListGroupItem,
  Row,
} from "react-bootstrap";
import AdminNavbar from "../AdminNavbar";
import RegForm from "./RegForm";

const RegisterNewUser = () => {
  let history = useHistory();
  let { email } = useParams();
  if (email) {
    email = decodeURIComponent(email);
  }
  const [results, setResults] = useState();
  let resultsView = (
    <Row>
      <ListGroup id="results">
        {results && (
          <>
            <ListGroupItem variant={results.createdReg ? "success" : "error"}>
              <Row>
                <h2>Create Registration Record</h2>
              </Row>
              <Row>
                <strong> {results.createdReg ? "success" : "error"} </strong>
              </Row>
            </ListGroupItem>
            <ListGroupItem
              variant={results.createdSubject ? "success" : "error"}
            >
              <Row>
                <h2>Created Subject Record</h2>
              </Row>
              <Row>
                <strong>
                  {" "}
                  {results.createdSubject ? "success" : "error"}{" "}
                </strong>
              </Row>
            </ListGroupItem>
            <ListGroupItem variant={results.updatedUser ? "success" : ""}>
              <Row>
                <h2>Connected to Existing User</h2>
              </Row>
              <Row>
                <strong>
                  {" "}
                  {results.updatedUser ? "success" : "No user exists yet"}{" "}
                </strong>
              </Row>
            </ListGroupItem>
          </>
        )}
      </ListGroup>
    </Row>
  );

  return (
    <>
      <AdminNavbar></AdminNavbar>
      <Jumbotron>
        <Container fluid={true}>
          <Row>
            <h1>Register a new User</h1>
          </Row>
        </Container>
      </Jumbotron>
      <Container fluid={true} style={{ backgroundColor: "white" }}>
        <RegForm email={email}></RegForm>
      </Container>
    </>
  );
};

export default RegisterNewUser;
